import { IHocSinhSelectAllRequest } from "../../../models/request/hoc-sinh/IHocSinhSelectAllRequest";
import { IHocSinhSelectRequest } from "../../../models/request/hoc-sinh/IHocSinhSelectRequest";
import { IHocSinhItemResponse } from "../../../models/response/crm-hocsinh/IHocSinhItemResponse ";
import { IHocSinh } from "../../../models/response/crm-hocsinh/IHocsinh";
import IGenericActionType from "../IGenericActionType";
import { generateActionTypeIds } from "../generateActionTypeIds";

// Định nghĩa các action types cho HocSinh API
export const objCrmHocSinhDefine = {
    LOAD_START: {} as IHocSinhSelectRequest,
    LOAD_SUCCESS: [] as IHocSinhItemResponse[], // Thay đổi `any` thành kiểu dữ liệu cụ thể nếu có
    LOAD_ERROR: "",
    UPDATE_ADVISOR_START: "",
    UPDATE_ADVISOR_SUCCESS: {},
    UPDATE_ADVISOR_ERROR: "",
    SEARCH_START: [] as any,
    SEARCH_SUCCESS: [] as IHocSinh[], // Thay đổi `any` thành kiểu dữ liệu cụ thể nếu có
    SEARCH_ERROR: "",
    GET_BY_ID_START: "",
    GET_BY_ID_SUCCESS: {},
    GET_BY_ID_ERROR: "",
    CHANGE_SELECTED_IDS: [] as number[], // Định nghĩa đúng loại cho payload
};

// Tạo action type IDs cho các action của HocSinh
export const eCrmHocSinhActionTypeIds = generateActionTypeIds(objCrmHocSinhDefine, "CRM_HOC_SINH");

// Định nghĩa type cho action types
export type ICrmHocSinhActionTypes = IGenericActionType<typeof objCrmHocSinhDefine, "CRM_HOC_SINH">;
